module.exports = __webpack_public_path__ + "static/media/certificate-trial.f6756aa2.svg";